// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"1d03a4f8","439":"29778aff","453":"2ec893a4","821":"4f0502fa","935":"db3e0bcf"}[chunkId] + ".chunk.js";
};